import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { AppConfig } from 'models/appConfig';
import { Community } from "types";

export interface AppState {
  loading: boolean;
  entity: any | null;
}

const initialState: AppState = {
  loading: false,
  entity: null,
};

const communitySlice = createSlice({
  name: 'community',
  initialState: initialState,
  reducers: {
    fetchCommunity(state, action: PayloadAction<string>) {
      state.loading = true;
    },
    fetchCommunitySuccess(state, action: PayloadAction<Community>) {
      state.loading = false;
      state.entity = action.payload;
    },
    fetchCommunityFailed(state, action: PayloadAction<unknown>) {
      state.loading = false;
    },
  },
});

// Actions
export const communityActions = communitySlice.actions;

// Selectors
export const selectCommunityLoading = (state: RootState) => state.community.loading;
export const selectCommunity = (state: RootState) => state.community.entity;

// Reducer
const commnunityReducer = communitySlice.reducer;
export default commnunityReducer;
